import React from 'react';
import { useWizard } from './WizardContext';
import { Table } from "react-bootstrap";
import LanguageToggle from "../LanguageToggle";
import { useGuestContext } from "../../../../contexts/GuestContext";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import cuteVege1 from "../../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../../assets/img/baolinPrivate/cute_vege2.png";
const Step3 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    relatives, setRelatives,
    timeslot,
  } = useWizard();
  const { language } = useGuestContext();
  const isValidated = () => {
    return true;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));



  const getDisplayTextForSelectionOption = () => {

    return language === "English" ? 'Bao Lin Vegefest 2026' : '寶林素食展 2026';
  };

  const getDisplayTrueOrFalse = (option) => {
    return language === "English" ? (option ? "Yes" : "No") : (option ? "是" : "否");
  };

  return (
    <div className="wizard-step">
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteVege1} alt="Company Logo" width="40" className="mr-3" />
        {language === "English" ? "Confirm your details" : "請確認所填信息無誤"}
        <img src={cuteVege2} alt="Company Logo" width="40" className="ml-3" />
      </p>

      <hr />
      <LanguageToggle />
      <hr />
      <Table striped hover>
        <thead>
          <tr>
            <th>{language === "English" ? "Item" : "項目"}</th>
            <th className='d-flex justify-content-center align-items-center'>{language === "English" ? "Information" : "資料"}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{language === "English" ? "Event Name" : "法會名稱"}</td>
            <td className='d-flex justify-content-center text-center'>{getDisplayTextForSelectionOption()}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Full English Name" : "英文全名"}</td>
            <td className='d-flex justify-content-center text-center'>{firstname + " " + lastname}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Chinese Name" : "中文姓名"}</td>
            <td className='d-flex justify-content-center text-center'>{chinesename ? chinesename : (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Email Address" : "郵箱地址"}</td>
            <td className='d-flex justify-content-center text-center'>{email}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Contact Phone" : "聯繫電話"}</td>
            <td className='d-flex justify-content-center text-center'>{phone}</td>
          </tr>

          <tr>
            <td>{language === "English" ? "Group Size (People Coming Along and yourself)" : "隨行人數（包括自己）"}</td>
            <td className='d-flex justify-content-center text-center'>
              {relatives}
            </td>
          </tr>
          <tr>
            <td>{language === "English" ? "Entry time" : "入場時段"}</td>
            <td className='d-flex justify-content-center text-center font-weight-bold'>
              {timeslot}
            </td>
          </tr>

        </tbody>
      </Table>
    </div>
  );
});

export default Step3;
